import {Component, Type} from '@angular/core';

@Component({
  selector: 'app-navigable-modal',
  templateUrl: './navigable-modal.component.html',
  styleUrls: ['./navigable-modal.component.scss'],
  standalone: false,
})
export class NavigableModalComponent {
  root: Type<unknown>;
  rootParams: Record<string, unknown>;
}
